export default "__VITE_ASSET__C1B0YFOW__"